module.exports = __webpack_public_path__ + "img/aboutus-juliana-image.f02e055b.png";